import styled from "styled-components";
import { device } from "../../../../../utils/utils";

export const BkngDtl = styled.div`
  @media ${device.mobileS} {
    
  }
`;
export const BkngDtlTab = styled.ul`
  display: flex;
  background: linear-gradient(265.41deg, #F6F4FF 25.52%, rgba(246, 244, 255, 0) 144.83%);
  border-top: 1px solid rgba(85, 66, 118, 0.17);
  border-bottom: 1px solid rgba(85, 66, 118, 0.17);
  @media ${device.mobileS} {
    
  }
`;
export const BkngDtlTabItem = styled.li`
  display: flex;
  padding: 12px 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #4A4A4A;
  border-right: 1px #EAE7FD solid;
  position: relative;
  &:last-child{
    border-right: 0;
  }
  ${p => p.isActive && `
    font-weight: 600;
    color: #4D3E6E;
    &:after{
      content: "";
      height: 3px;
      border-radius: 13px;
      background-color: #4D3E6E;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  `}
  @media ${device.mobileS} {
    
  }
`;
export const BkngDtlBody = styled.div`
  padding: 0 20px;
  @media ${device.mobileS} {
    padding: 0;
    max-height: 360px;
    overflow-y: auto;
  }
`;
export const BkngDtlRow = styled.div`
  display: flex;
  border-bottom: 1px solid rgba(85, 66, 118, 0.17);
  padding: 17px 6px;
  align-items: center;
  &:last-child{
    border-bottom: 0;
  }
  @media ${device.mobileS} {
    padding: 16px;
  }
`;
export const BkngDtlCol = styled.div`
  &:nth-child(1){
    width: 140px;
    flex-shrink: 0;
  }
  &:nth-child(2),
  &:nth-child(3){
    flex: 1;
  }
  &:nth-child(2){
    padding-left: 35px;
  }
  &:nth-child(3){
    text-align: right;
  }
  @media ${device.mobileS} {
    
  }
`;
export const BkngDtlHdng = styled.h4`
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
  color: #000;
  display: flex;
  align-items: center;
  .sprite{
    margin: 0 3px;
  }
  @media ${device.mobileS} {
    
  }
`;
export const BkngDtlBkngid = styled.p`
  font-size: 10px;
  line-height:  15px;
  span{
    font-weight: 700;
  }
  @media ${device.mobileS} {
    
  }
`;
export const BkngDtlPrice = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #313131;
  @media ${device.mobileS} {
    
  }
`;